import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {ROUTES} from '../../app.routes';

/**
 * The auth-guard service checks whether a user is logged in and redirects the user back to the
 * login page if he/she is not. The auth-guard service is configured on each individual route
 * if it required the user to be logged in.
 */
@Injectable()
export class AuthGuardService implements CanActivate
{

    constructor(private router: Router, protected authenticationService: AuthenticationService)
    {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        if (this.authenticationService.getUserLogin())
        {
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate([ROUTES.PUBLIC.LOGIN.path]).then();
        return false;
    }
}